import {connect} from "react-redux";
import {Modal} from "bootstrap";
import AppBaseComponent from '../../../../components/AppBaseComponent';
import HttpAPICall from "../../../../services/HttpAPICall";
import Loader from "../../../../components/ui/Loader/Loader";
import { ORG_API_BASE_URL_2 } from "../../../../services/TapApiUrls";
import {toast} from "react-toastify";
import * as actions from '../../../../store/actions/index';
import TapIcon from "../../../../services/TapIcon";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

class General extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.config_data                =   [
            {key : 'employee_workflow_enable_tag_asset', name: 'Enable Tag Asset in Employee WorkLog', value: ''},
            {key : 'employee_workflow_enable_tag_ticket', name: 'Enable Tag Ticket in Employee Worklog', value: ''},
            {key : 'employee_workflow_enable_tag_workstation', name: 'Enable Tag Workstation in Employee Worklog', value: ''}

        ];

        this.state                              =   {
            generalConfigloading                :   false,
            general_config_list                 :   this.config_data,
            generalConfigForm                   :   {key : '', value : '', name : ''},
            editFormSubmiting                   :   false,
            tabType                             :   ''
        };

        this.settingEditUrl =   ORG_API_BASE_URL_2  + '/setting_edit';
        this.settingUrl     =   ORG_API_BASE_URL_2  + '/settings/v2'
    }

    componentDidMount() {
        this.getGeneralSettingListing();
        this.editGeneralConfiguration        =        new Modal(document.getElementById('editGeneralConfigurationModal'), {keyboard: false, backdrop :false});
   }

    getGeneralSettingListing = () => {
        let params = {
            setting_for: "employee",
            keys    :   ['employee_workflow_enable_tag_asset', 'employee_workflow_enable_tag_ticket', 'employee_workflow_enable_tag_workstation'],
        }
        this.setState({ generalConfigloading: true });
        HttpAPICall.withAthorization('GET', this.settingUrl, this.props.access_token, {...params}, {}, (resp) => {
            let data            =   resp.data;

            this.setState({ 
                general_config_list :   data 
                ? data.map(cd => {
                        let newData =   cd;
                        this.config_data.forEach(d => {
                            if(d.key === cd.key) {
                                newData     =   {...newData, name: d.name}
                            }
                        });
                        return newData;
                    }) 
                : [] 
            })
        }).then(() => this.setState({ generalConfigloading: false }));
    }

    editGeneralConfigurationInit = (data) => {
        this.editGeneralConfiguration.show();
        if(this.state.general_config_list) {
            this.setState({
                generalConfigForm   :   data
            })
        }
    }

    submitGeneralConfigurationForm        =    (e)          =>     {
        e.preventDefault();
        this.setState({editFormSubmiting : true});
        let params          =   {
            update_with_link_id :   true,
            setting_id          :   this.state.generalConfigForm.id,
            value               :   this.state.generalConfigForm.value,
        };
        HttpAPICall.withAthorization('PUT', this.settingEditUrl, this.props.access_token, {}, params, (response) => {
            toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
            this.editGeneralConfiguration.hide();
            this.getGeneralSettingListing();
            this.props.applicationInitLoading(this.props.access_token);
        }).then(() => this.setState({editFormSubmiting: false}));
    }

    handleFormData =   (e)  => {
        this.setState({
            generalConfigForm :   {...this.state.generalConfigForm, value : e.target.value} 
        })
    }

    editGeneralConfigurationModalJsx      =    ()           =>     {
        const {generalConfigForm}   =   this.state;
        return (
            <div className="modal fade" id="editGeneralConfigurationModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">Edit General Configuration</h5>
                        </div>
                        <form onSubmit={this.submitGeneralConfigurationForm}>
                            <div className="modal-body p-3">
                            
                                <div className="row align-items-center mb-2 mt-2 px-2">
                                    <div className="col-md-9"><label className="form-label">{generalConfigForm.name}</label></div>
                                    {
                                        ['Y', 'N'].includes(generalConfigForm.value)
                                        ?
                                        <>
                                        <div className="col-md-1">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={generalConfigForm.key}
                                                    value="Y"
                                                    onChange={(e) => this.handleFormData(e)}
                                                    checked={generalConfigForm.value === "Y"}
                                                /> Yes
                                            </label>
                                        </div>
                                        <div className="col-md-2">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={generalConfigForm.key}
                                                    value="N"
                                                    onChange={(e) => this.handleFormData(e)}
                                                    checked={generalConfigForm.value == "N"} /> No
                                            </label>
                                        </div>
                                        </>
                                        :
                                        <div className="col-md-3">
                                            <label>
                                                <input
                                                type="text"
                                                name={generalConfigForm.key}
                                                value={generalConfigForm.value}
                                                className="form-control"
                                                onChange={(e) => this.handleFormData(e)} />
                                            </label>
                                        </div>
                                    }
                                </div>
                              
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" disabled={this.state.editFormSubmiting} data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary" disabled={this.state.editFormSubmiting} >Save {this.state.editFormSubmiting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : null}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    generalConfigurationJsx               =    ()           =>     {
        let {generalConfigloading, general_config_list}    =   this.state;
        
        return (<table className="table table-hover table-bordered my-4 ">
            <thead className="table-secondary">
                <tr className="text-center">
                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                    <th scope="col" className="text-start">Configuration</th>
                    <th scope="col" style={{ width: "25%" }} >Value</th>
                    <th scope="col" style={{ width: "8%" }} >Action</th>
                </tr>
            </thead>
            <tbody>
                {
                    generalConfigloading 
                    ? <tr className="text-center"><td colSpan={4}><Loader/></td></tr>
                    : general_config_list.length > 0 
                    ? general_config_list.map((data, i) => (
                        <tr className="text-center" key={i}>
                            <td>{i+1}</td>
                            <td className="text-start">{data.name}</td>
                            <td>{data.value === "Y" ? "Yes" : (data.value === "N" ? "No"  : data.value)}</td>
                            <td className="text-center">
                                <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li><Link className="dropdown-item" role="button" onClick={() => this.editGeneralConfigurationInit(data)}>Edit</Link></li>
                                </ul>
                            </td>
                        </tr>
                    ))
                    : <tr className="text-center"><td colSpan={4}>No Record Found</td></tr>
                }
              
           
            </tbody>
        </table>)
    }

    render                                  =     ()           =>     {
        return (<section className="page_containt" style={{ top: "1px" }}>
                <div className=" bg-white">
                  {this.generalConfigurationJsx()}
                </div>
                {this.editGeneralConfigurationModalJsx()}
        </section>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :        state.auth.access_token,
        permissions             :       state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        applicationInitLoading  :   (access_token)  =>  dispatch(actions.applicationInitLoading(access_token, false))
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(General);